import { Textarea } from "@/ui-components/ui/textarea";
import { zodResolver } from "@hookform/resolvers/zod";
import { UpdateIcon } from "@radix-ui/react-icons";
import { XIcon } from "lucide-react";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { Button } from "../../ui-components/ui/button";
import { Form, FormControl, FormField, FormItem, FormMessage } from "../../ui-components/ui/form";

const formSchema = z.object({
  information: z.string(),
});

type FormValues = z.infer<typeof formSchema>;

interface InformationFormProps {
  onSubmit: (values: FormValues) => void;
  defaultValue?: string;
  onCancel: () => void;
}

const InformationForm = ({ onSubmit, defaultValue, onCancel }: InformationFormProps) => {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      information: defaultValue || "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <FormField
          control={form.control}
          name="information"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Textarea placeholder="Informationen eingeben..." {...field} className="h-40" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex flex-row gap-2">
          <Button size="icon" onClick={onCancel} variant="ghost">
            <XIcon className="h-4 w-4" />
          </Button>
          <Button type="submit" className="gap-2 grow">
            {defaultValue ? (
              <>
                <UpdateIcon className="h-4 w-4" /> Aktualisieren
              </>
            ) : (
              "Speichern"
            )}
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default InformationForm;
